import { Injectable, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';

export type MessageInfo = {
	type: 'error' | 'success' | 'info' | 'warn';
	title: string;
	text: string;
	redirect?: boolean;
};

@Injectable({
	providedIn: 'root'
})
export class MessagesService {
	readonly #translate = inject(TranslateService);
	#messageSubject = new Subject<MessageInfo>();
	message$ = this.#messageSubject.asObservable();

	sendMessageTranslate(val: MessageInfo) {
		const message = {
			type: val.type,
			title: this.#translate.instant(val.title),
			text: this.#translate.instant(val.text),
			redirect: val.redirect ?? false
		};
		this.#messageSubject.next(message);
	}

	sendMessage(val: MessageInfo) {
		this.#messageSubject.next(val);
	}
}
